/** Preferred public origin — must match live host (www → apex redirect in vercel.json). */
export const SITE_ORIGIN = 'https://soldikeeper.com';
export const SITE_NAME = 'SoldiKeeper';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/assets/images/og-image.png`;
export const DEFAULT_LOGO = `${SITE_ORIGIN}/logo512.png`;

export function absoluteUrl(path = '/') {
  if (!path) return `${SITE_ORIGIN}/`;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
